import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'demo-upp-textarea',
    templateUrl: './demo-upp-textarea.html',
    styleUrls: ['../demo-common.scss', './demo-upp-textarea.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppTextareaComponent implements OnInit {
    form!: FormGroup;
    isReadonly = false;

    errorMessages: Record<string, string> = {
        required: 'This field is required',
    };

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            shortDescription: new FormControl('', [Validators.required]),
            detailedNotes: new FormControl(''),
        });
    }

    get shortDescriptionLength(): number {
        return (this.form.get('shortDescription')?.value || '').length;
    }

    get detailedNotesLength(): number {
        return (this.form.get('detailedNotes')?.value || '').length;
    }

    toggleReadonly() {
        this.isReadonly = !this.isReadonly;
        this.change.markForCheck();
    }

    validate() {
        Object.values(this.form.controls).forEach(c => {
            c.markAsTouched();
            c.markAsDirty();
        });
        this.change.markForCheck();
    }

    resetForm() {
        this.form.reset();
        this.isReadonly = false;
        this.change.markForCheck();
    }
}
